import type { QualityMetricKey } from "../../api/catalog-contracts";
import type { MessageKey } from "../../i18n/dictionaries";

// Each curated metric → its (Turkish-first) label key. Kept beside the surface so a
// new metric is a single, typed addition.
export const METRIC_LABEL_KEYS: Record<QualityMetricKey, MessageKey> = {
  claimsPaymentSpeedDays: "metric.claimsPaymentSpeedDays",
  claimsAcceptanceRatio: "metric.claimsAcceptanceRatio",
  complaintRatio: "metric.complaintRatio",
  serviceScore: "metric.serviceScore",
  solvencyRatio: "metric.solvencyRatio",
  networkStrength: "metric.networkStrength",
};

// U7 — per-metric help text (what it is · unit/range · direction). Ranges are grounded in
// the DB column scales (packages/db/src/schema/catalog.ts): scale-4 numerics are ratios
// (0–1), scale-2 numerics are 0–100 scores (serviceScore is explicitly 0–100 in
// scoring.ts), and claimsPaymentSpeedDays is in days — never fabricated.
export const METRIC_HELP_KEYS: Record<QualityMetricKey, MessageKey> = {
  claimsPaymentSpeedDays: "metric.claimsPaymentSpeedDays.help",
  claimsAcceptanceRatio: "metric.claimsAcceptanceRatio.help",
  complaintRatio: "metric.complaintRatio.help",
  serviceScore: "metric.serviceScore.help",
  solvencyRatio: "metric.solvencyRatio.help",
  networkStrength: "metric.networkStrength.help",
};
